<template>
  <Sonner
    :class="cn('tw:toaster tw:group', props.class)"
    :style="{
      '--normal-bg': 'var(--primary)',
      '--normal-text': 'var(--primary-foreground)',
      '--normal-border': 'var(--primary)',
      '--border-radius': 'var(--radius-card)',
    }"
    v-bind="props"
  >
    <template #success-icon>
      <CircleCheckIcon class="tw:icon-action" />
    </template>
    <template #info-icon>
      <InfoIcon class="tw:icon-action" />
    </template>
    <template #warning-icon>
      <TriangleAlertIcon class="tw:icon-action" />
    </template>
    <template #error-icon>
      <OctagonXIcon class="tw:icon-action" />
    </template>
    <template #loading-icon>
      <div>
        <Loader2Icon class="tw:icon-action tw:animate-spin" />
      </div>
    </template>
    <template #close-icon>
      <XIcon class="tw:icon-action" />
    </template>
  </Sonner>
</template>

<script setup>
defineOptions({ name: 'UiSonner' });
import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
  XIcon,
} from '@lucide/vue';
import { cn } from '@/shared/utilities/classes';
import { Toaster as Sonner } from 'vue-sonner';
import 'vue-sonner/style.css';

const props = defineProps({
  id: { default: undefined, type: String, required: false },
  invert: { default: undefined, type: Boolean, required: false },
  theme: { default: undefined, type: String, required: false },
  position: { default: undefined, type: String, required: false },
  closeButtonPosition: { default: undefined, type: String, required: false },
  hotkey: { default: undefined, type: Array, required: false },
  richColors: { default: undefined, type: Boolean, required: false },
  expand: { default: undefined, type: Boolean, required: false },
  duration: { default: undefined, type: Number, required: false },
  gap: { default: undefined, type: Number, required: false },
  visibleToasts: { default: undefined, type: Number, required: false },
  closeButton: { default: undefined, type: Boolean, required: false },
  toastOptions: { default: undefined, type: Object, required: false },
  class: { default: undefined, type: String, required: false },
  style: { default: undefined, type: Object, required: false },
  offset: { default: undefined, type: [Object, String, Number], required: false },
  mobileOffset: { default: undefined, type: [Object, String, Number], required: false },
  dir: { default: undefined, type: String, required: false },
  swipeDirections: { default: undefined, type: Array, required: false },
  icons: { default: undefined, type: Object, required: false },
  containerAriaLabel: { default: undefined, type: String, required: false },
});
</script>
